import { useState } from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

import { useLinkProjectToProjectdossier } from '../../hooks/useLinkProjectToProjectdossier'

interface Props {
  dossierId: string
  onClose: () => void
}

export const LinkProjectDialog = ({ dossierId, onClose }: Props) => {
  const { mutate: linkProjectToProjectdossier } =
    useLinkProjectToProjectdossier()
  const [projectId, setProjectId] = useState('')
  const [errors, setErrors] = useState({})

  const validate = () => {
    const idError = !projectId

    setErrors({
      idError,
    })

    return !idError
  }

  const handleClickJa = () => {
    if (validate()) {
      linkProjectToProjectdossier(
        { id: dossierId, projectId },
        { onSuccess: () => onClose() },
      )
    }
  }

  return (
    <Dialog open fullWidth>
      <DialogTitle>Koppelen project</DialogTitle>
      <DialogContent>
        <TextField
          variant="standard"
          value={projectId}
          onChange={(e) => setProjectId(e.target.value.trim())}
          label="ID van het project"
          fullWidth
          error={errors['idError']}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button onClick={handleClickJa} color="primary">
          Koppelen
        </Button>
      </DialogActions>
    </Dialog>
  )
}
